import { FlexProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getCurrentQuote } from '../../../domain'
import { useEditProposalCallback } from '../../../hooks/proposal'
import { ProductKind } from '../../../state/configuration'
import { toDateTime } from '../../../util/date'
import { useProduct } from '../../product/productContext'
import { useProposal } from '../../product/proposal/ProposalProvider'
import { QuoteDetailsView } from '../quote'

export const ProposalDetailsView: FunctionComponent<FlexProps> = (props) => {
  const { product } = useProduct()
  const { proposal } = useProposal()

  const quote = getCurrentQuote(proposal)
  const onEdit = useEditProposalCallback(proposal)

  const startAt = toDateTime(proposal.startAt)
  const endAt =
    product.productKind === ProductKind.SUBSCRIPTION
      ? undefined
      : toDateTime(proposal.endAt)

  return (
    <QuoteDetailsView
      onEdit={onEdit}
      quote={quote}
      startAt={startAt}
      endAt={endAt}
      {...props}
    />
  )
}
